/**
 * Offline detection and error handling utilities
 * Provides centralized offline detection for API calls
 */

/**
 * Check if error is network/offline related
 * @param {Error} error - The error object to check
 * @returns {boolean} - True if error is offline-related
 */
export const isOfflineError = (error) => {
  if (!navigator.onLine) return true;
  
  const errorMessage = error?.message?.toLowerCase() || '';
  const errorCode = error?.code || '';
  const errorName = error?.name || '';
  
  return (
    errorMessage.includes('network error') ||
    errorMessage.includes('cors') ||
    errorMessage.includes('failed to fetch') ||
    errorMessage.includes('networkerror') ||
    errorCode === 'ECONNABORTED' ||
    errorCode === 'ENOTFOUND' ||
    errorCode === 'ERR_NETWORK' ||
    errorName === 'NetworkError' ||
    error?.response === undefined // Axios network error (no response = network issue)
  );
};

/**
 * Get user-friendly offline error message (non-intrusive)
 * @returns {string} - User-friendly message
 */
export const getOfflineMessage = () => {
  return "No internet connection. Your answer is saved and will be submitted automatically when connection is restored.";
};

/**
 * Get user-friendly offline message for final submission
 * @returns {string} - User-friendly message for test submission
 */
export const getOfflineSubmissionMessage = () => {
  return "No internet connection. Your test submission is queued and will be submitted automatically when connection is restored.";
};

